define('collections/t1AppEdit',["jQuery", "Underscore", "T1", "T1Collection", "models/t1AppEdit", "T1Sortable"], function ($, _, T1, T1Collection, Model) {
  "use strict";

  T1Collection.extend({
    apiRoot: T1.API_APPS_ROOT,
    canCache: false,
    cacheDuration: 6e4,
    model: Model,
    urlString: ""
  });
  return T1.Models.T1AppsEdit;
});
